import type { StylableElementProps } from '@subaio/components'

import { BrandLogo } from './BrandLogo'

type Props = StylableElementProps & {
	brandId?: string
	height?: number
}

export const BrandOriginal = ({ height = 54, brandId, className, style }: Props) => (
	<BrandLogo height={height} brandId={brandId} className={className} style={style} />
)
